module.exports = __webpack_public_path__ + "static/img/pin-passenger.91c1acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pin-passenger.png
// module id = khWv
// module chunks = 1